export function formatWrittenDateDisplay(dateString: string) {
  /* For date strings, it assumes UTC and converts to Eastern (making it the day before) */
  const date = Date.parse(dateString);

  return Intl.DateTimeFormat("en-US", {
    dateStyle: "long",
    timeZone: "America/New_York"
  }).format(date);
}
